import React from "react";
import { Navigate } from "react-router-dom";
import { useSession } from "../context/SessionContext";
import { LoadingScreen } from "./LoadingScreen";
import { PATHS } from "./paths";

interface AdminRouteProps {
  children: React.ReactElement;
}

/**
 * Guard da rota `/admin`. Deve ficar DENTRO de `<ProtectedRoute>` (que garante
 * autenticação e dispara a verificação de `adminStatus`).
 *
 * - `adminStatus === null` → verificação em andamento, mostra loading.
 * - `is_admin === false`   → redireciona para a home (o backend também bloqueia
 *   com 403, tratado nas chamadas de API).
 */
export const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { adminStatus } = useSession();

  if (adminStatus === null) return <LoadingScreen />;
  if (!adminStatus.is_admin) return <Navigate to={PATHS.newOrder} replace />;

  return children;
};
